export const getResultsScreenDisplayMode = (hasSavedResults, experimentId) => {
    /**
     * Supports A/B testing for iSelect Car and Home & Contents journeys by 
     * setting the default results view to "Quick Price".
     */
    if (experimentId === 'expResultView') {
        return 'row';
    }
    return hasSavedResults ? 'row' : 'column';
};